import req from "../http";

const c1111 = {
  // 下載 範本
  getResumeTemplate() {
    return req("get", "/ResumeModule/C1111/GetImportResumeTemplate", null, { responseType: "blob" });
  },

  // 預覽1111 履歷匯入結果
  previewResume(params) {
    return req("post", "/ResumeModule/C1111/PreviewImportResume", params, { headers: { "Content-Type": "multipart/form-data" } });
  },

  // 1111 履歷
  importResume(params) {
    return req("post", "/ResumeModule/C1111/ImportResume", params, { headers: { "Content-Type": "multipart/form-data" } });
  }
};

export default c1111;